export default ({ commit }, params) => {
  return new Promise((resolve, reject) => {
    window.addEventListener('message', (e) => {
      let data = JSON.parse(e.data)

      if (data.result === 1) {
        let message = {
          action: 'getInfo'
        }
        window.top.postMessage(JSON.stringify(message), '*')
      } else {
        resolve(data)
      }
    }, false)

    let message = {
      action: 'getInfo'
    }
    window.top.postMessage(JSON.stringify(message), '*')
  })
}



// WEBPACK FOOTER //
// ./src/store/modules/shappy/actions/sendShappyPostMessage.js